(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (window.location.pathname === '/collections/christmas') {
    const sectionStyles = document.createElement('style');
    sectionStyles.id = 'pine-christmas-sections-style';
    sectionStyles.textContent =
      '.pine-christmas-heading{grid-column:1/-1;list-style:none;margin:clamp(28px,5vw,56px) 0 4px;padding:clamp(20px,3vw,32px);border-radius:22px;text-align:center;background:rgb(var(--color-background-rgb));border:1px solid rgb(var(--color-foreground-rgb)/.12)}' +
      '.pine-christmas-heading:first-child{margin-top:8px}' +
      '.pine-christmas-heading h2{margin:0;font-size:clamp(28px,4vw,44px);line-height:1.1}' +
      '.pine-christmas-heading p{max-width:620px;margin:10px auto 0;opacity:.78}';
    document.head.appendChild(sectionStyles);

    const gridSelector = 'ul[data-testid="product-grid"]';
    const christmasSections = [
      {
        key: 'grinch',
        title: 'Grinch Collection',
        description: 'Mischievous, merry and full of Grinchmas fun.'
      },
      {
        key: 'santa',
        title: 'Santa Collection',
        description: 'Keepsakes for Christmas Eve and Santa’s visit.'
      },
      {
        key: 'plaques',
        title: 'Christmas Plaques',
        description: 'Personalised crate plaques made for Christmas morning.'
      },
      {
        key: 'sentimental',
        title: 'Sentimental Christmas',
        description: 'Meaningful ornaments and traditions to treasure.'
      }
    ];

    let christmasObserver;

    const groupForChristmasTitle = (title) => {
      const name = title.toLowerCase();
      if (name.includes('grinchmas')) return 'grinch';
      if (name.includes('santa') || name.includes('christmas eve milk')) return 'santa';
      if (name.includes('plaque')) return 'plaques';
      return 'sentimental';
    };

    const arrangeChristmasProducts = () => {
      const grid = document.querySelector(gridSelector);
      if (!grid) return;

      if (christmasObserver) christmasObserver.disconnect();

      grid.querySelectorAll(':scope > .pine-christmas-heading').forEach((heading) => heading.remove());

      const groups = {
        grinch: [],
        santa: [],
        plaques: [],
        sentimental: []
      };

      grid.querySelectorAll(':scope > li.product-grid__item').forEach((item) => {
        const title =
          item.querySelector('[role="heading"][aria-level="3"]')?.textContent?.trim() ||
          item.querySelector('product-card')?.getAttribute('view-event-payload') ||
          '';
        groups[groupForChristmasTitle(title)].push(item);
      });

      christmasSections.forEach((section) => {
        if (!groups[section.key].length) return;

        const heading = document.createElement('li');
        heading.className = 'pine-christmas-heading';
        heading.innerHTML =
          '<h2>' + section.title + '</h2>' +
          '<p>' + section.description + '</p>';
        grid.appendChild(heading);

        groups[section.key].forEach((item) => grid.appendChild(item));
      });

      if (christmasObserver) christmasObserver.observe(grid, { childList: true });
    };

    const initialiseChristmasSections = () => {
      const grid = document.querySelector(gridSelector);
      if (!grid) return;

      christmasObserver = new MutationObserver(arrangeChristmasProducts);
      arrangeChristmasProducts();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseChristmasSections, { once: true });
    } else {
      initialiseChristmasSections();
    }
  }
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
